import { ReactElement } from 'react';
import { Alert } from 'antd';

import { FormGeneralErrorsProps } from './interfaces';
import styles from './styles.module.css';

export const FormGeneralErrors = ({ errors }: FormGeneralErrorsProps): ReactElement | null => {
  if (!errors?.length) return null;

  return (
    <div data-form-general-error className={styles.container}>
      <Alert
        type="error"
        showIcon
        title={
          errors.length === 1 ? (
            errors[0]
          ) : (
            <ul className={styles.list}>
              {errors.map(error => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          )
        }
      />
    </div>
  );
};
